import { IntegrationsPanel } from '@/features/integrations';

import { AdminHeader } from './components/AdminHeader';
import { adminCopy } from './copy';

/**
 * Platformbeheer - Koppelingen: de sleutels van de beheer-MCP (`/mcp/beheer`).
 *
 * Een beheersleutel hoort bij geen enkel keuringsbedrijf en draagt alleen de scope
 * `platform:admin`; hij opent de beheer-MCP en niets anders. Elke wijziging die een
 * agent daarmee doet, vraagt een bevestiging en staat in het auditlog met "via MCP"
 * en de beheerder.
 */
export function AdminIntegrationsPage() {
    return (
        <div className="flex min-h-0 flex-1 flex-col">
            <AdminHeader
                eyebrow={`${adminCopy.eyebrowPlatform} · ${adminCopy.integrationsEyebrow}`}
                title={adminCopy.integrationsTitle}
            />

            <div className="flex flex-1 flex-col gap-[14px] overflow-auto bg-[var(--surface-page)] px-7 pt-[22px] pb-8">
                <p className="m-0 max-w-[720px] text-[13px] leading-[1.5] text-[var(--text-secondary)]">
                    {adminCopy.integrationsIntro}
                </p>
                <IntegrationsPanel owner="platform" />
            </div>
        </div>
    );
}
